import { Yo } from "../../assets.jsx";
import { Xo } from "../../assets.jsx";
import { c_ } from "../../assets.jsx";
import { u_ } from "../../assets.jsx";
import { o_ } from "../../assets.jsx";
import { r_ } from "../../assets.jsx";
import { Qo } from "../../assets.jsx";
import { Zo } from "../../assets.jsx";
import { Vo } from "../../assets.jsx";
import { d_ } from "../../assets.jsx";
import { f_ } from "../../assets.jsx";
import { $o } from "../../assets.jsx";
import { Ko } from "../../assets.jsx";
import { h_ } from "../../assets.jsx";
import { m_ } from "../../assets.jsx";
import { hm } from "../../assets.jsx";
import { Jo } from "../../assets.jsx";
import { p_ } from "../../assets.jsx";
import { Ii } from "../../assets.jsx";
import { jn } from "../../assets.jsx";
import { Ns } from "../../assets.jsx";
import { Mo } from "../../assets.jsx";
import { i_ } from "../../assets.jsx";

export const mm = {
  gems: {
    common: Yo,
    rare: Xo,
    epic: c_,
    legendary: u_,
    mythic: o_
  },
  spins: {
    common: r_,
    rare: Qo,
    epic: Zo,
    legendary: Vo,
    mythic: d_
  },
  shells: {
    common: f_,
    rare: $o,
    epic: Ko,
    legendary: h_,
    mythic: m_
  }
};
export const pm = {
  LIMITED: hm,
  Лимитка: hm,
  Mystic: Jo,
  Theme: p_
};
export const js = (u, o, m) => m && pm[m] ? pm[m] : u && o && u in mm ? mm[u][o] : void 0;

export const getCaseRewardImage = js;
